export default __webpack_public_path__ + "static/media/carpe.fb3bfbcd.png";